import { type Socket } from "socket.io-client";
import { createContext, useContext, type ReactNode } from "react";

const Ctx = createContext<{ socket: Socket | null }>({ socket: null });

export function DispensarySocketProvider({
  socket,
  children,
}: {
  socket: Socket | null;
  children: ReactNode;
}) {
  return <Ctx.Provider value={{ socket }}>{children}</Ctx.Provider>;
}

export function useDispensarySocketInstance(): Socket | null {
  return useContext(Ctx).socket;
}
